import Swal from "sweetalert2";

export default Swal.mixin({
  customClass: {
    confirmButton:
      "!bg-deepsea-full !border !border-deepsea-full hover:!bg-deepsea-full/75 focus:!ring-deepsea-medium focus:!ring-2 focus:!ring-offset-1"
  }
});
